// Copyright (c) 2017 Deere & Company

import OpenPipsMain from './open-pips-main';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    busyCounter: state.pips.openPips.busyCounter,
    exportToExcel: state.exportToExcel,
    facets: state.pips.openPips.facets,
    hasSearchResults: state.pips.openPips.hasSearchResults,
    laborAdditivePipProductsCount: state.pips.laborAdditive.pipProducts.length,
    pipProductsCount: state.pips.openPips.pipProducts.length,
    pipProductsFiltered: state.pips.openPips.pipProductsFiltered,
    searchFilters: state.pips.openPips.searchFilters,
    searchResultsCount: state.pips.pipSearch.searchResults.length,
    security: state.user.security
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;
    const {updateListFilterBy, updateListSortBy, updateListSortDirection} = dispatchProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        onFilterByChange: updateListFilterBy,
        onSortByChange: updateListSortBy,
        onSortDirectionChange: updateListSortDirection,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(OpenPipsMain);



// WEBPACK FOOTER //
// ./src/pip/open-pips/components/open-pips-main/index.js